import { Box } from '@material-ui/core';
import { MerchantStructure } from '@nemuru-eng/js-api-client';

import { NewAgentCloned } from '../Agents/types/NewAgentCloned';
import { SectionTitle } from '../SectionTitle';
import { ProcessingAgentCard } from './components/ProcessingAgentCard';

interface ProcessingProps {
  isSubmitting: boolean;
  agents?: NewAgentCloned[];
  merchantStructure: MerchantStructure;
}
export const Processing = ({ isSubmitting, agents, merchantStructure }: ProcessingProps) => {
  if (!agents) {
    return null;
  }

  return (
    <>
      <SectionTitle titleId={isSubmitting ? 'PROCESSING_WITH_DOTS' : 'SUMMARY'} />
      <Box minHeight={'300px'}>
        {agents.map((agent) => (
          <Box mt={2} key={agent.agentId}>
            <ProcessingAgentCard agent={agent} merchantStructure={merchantStructure} />
          </Box>
        ))}
      </Box>
    </>
  );
};
